import { DisplayItem } from 'design-system';

/**
 * Unified source for the gender options
 */
const genders: DisplayItem[] = [
  { Value: 'M', Text: 'Masculino' },
  { Value: 'F', Text: 'Femenino' },
];
export default genders;
